import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'

const JobDetails = () => {
  const { jobs, isLoading } = useSelector((state) => state.jobs)

  const columns = [
    {
      title: 'Job Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
    },
    {
      title: 'Originating Server',
      dataIndex: 'originatingServerName',
      key: 'originatingServerName',
      width: '12%',
    },
    {
      title: 'Step ID',
      dataIndex: 'stepId',
      key: 'stepId',
      width: '6%',
    },
    {
      title: 'Step Name',
      dataIndex: 'stepName',
      key: 'stepName',
      width: '12%',
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency',
      width: '8%',
    },
    {
      title: 'Schedule Time',
      dataIndex: 'scheduleTime',
      key: 'scheduleTime',
      width: '8%',
    },
    {
      title: 'Database Name',
      dataIndex: 'databaseName',
      key: 'databaseName',
      width: '10%',
    },
    {
      title: 'Owner',
      dataIndex: 'owner',
      key: 'owner',
      width: '8%',
    },
    {
      title: 'Run Status',
      dataIndex: 'runStatus',
      key: 'runStatus',
      width: '8%',
      render: (status) => {
        const statusMap = { 0: 'Failed', 1: 'Succeeded', 2: 'Retry', 3: 'Canceled', 4: 'In Progress' }
        return statusMap[status] || status
      },
    },
    {
      title: 'Last Run Date',
      dataIndex: 'lastRunDate',
      key: 'lastRunDate',
      width: '10%',
      render: (date) => date ? new Date(date).toLocaleDateString() : 'N/A',
    },
    {
      title: 'Next Run Date',
      dataIndex: 'nextRunDate',
      key: 'nextRunDate',
      width: '10%',
      render: (date) => date ? new Date(date).toLocaleDateString() : 'N/A',
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      width: '6%',
      render: (isActive) => isActive ? 'Yes' : 'No',
    },
  ]

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!jobs || jobs.length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  return (
    <CommonTable
      columns={columns}
      dataSource={jobs}
      rowKey="jobId"
    />
  )
}

export default JobDetails
